import React from "react";

const WorkoutNavigation = ({
  weeks,
  currentweek,
  currentDay,
  onWeekChange,
  onDayChange,
  cweek
}) => {
  const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  return (
    <div className="workout-navigation">
      <div className="week-navigation">
        <h4>Select Week</h4>
        <div className="week-buttons">
          {weeks?.map((week) => (
            <button
              key={week}
              className={`week-btn ${week == cweek || week == currentweek ? "active" : ""}`}
              onClick={() => onWeekChange(week)}
            >
              Week {week}
            </button>
          ))}
        </div>
      </div>
      
      <div className="day-navigation">
        <h4>Select Day</h4>
        <div className="day-buttons">
          {days.map((day) => (
            <button
              key={day}
              className={`day-btn ${currentDay === day ? "active" : ""}`}
              onClick={() => onDayChange(day)}
            >
              {day.slice(0, 3)}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WorkoutNavigation;
